import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { GzListItemWebComponent } from '../../../../ui/gzListItem';
import { translateFn } from '../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../ui/gzForm/validators/required.validator';
import { MaxLengthValidator } from '../../../../ui/gzForm/validators/max-length.validator';
import { RemoteValidator } from '../../../../ui/gzForm/validators/remote.validator';
import { TAG_NAME_MAX_LENGTH } from '../../../common/constants';
import { MinLengthValidator } from '../../../../ui/gzForm/validators/min-length.validator';

export class InlineTagFormView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $addTagButton: GzButtonWebComponent;
    $addTagButtonText: HTMLElement;
    $tagNameListItem: GzListItemWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $addTagButton: this.shadow.querySelector('#addTagButton'),
      $addTagButtonText: this.shadow.querySelector('#addTagButtonText'),
      $tagNameListItem: this.shadow.querySelector('#tagNameListItem'),
    };
  }

  buildSuccessView(data) {
    this.dom.$addTagButtonText.innerHTML = translateFn('Create tag');
    const { minLength, maxLength, customValidators } = data;

    this.dom.$tagNameListItem.errorMessage = [
      RequiredValidator(this.commonStrings.requiredField),
      MaxLengthValidator(
        maxLength,
        translateFn('The name can have a maximum of {tagNameMaxLength} characters.', {
          tagNameMaxLength: maxLength,
        })
      ),
    ];

    if (minLength > 0) {
      this.dom.$tagNameListItem.errorMessage.push(
        MinLengthValidator(
          minLength,
          translateFn('The name can have a minimum of {tagNameMinLength} characters.', {
            tagNameMinLength: minLength,
          })
        )
      );
    }

    if (customValidators.length) {
      this.dom.$tagNameListItem.errorMessage.push(...customValidators);
    }

    if (this.dom.$tagNameListItem.noBackend) {
      return;
    }

    this.dom.$tagNameListItem.errorMessage.push(
      RemoteValidator(
        (value: string) => this.dependencies.api.clients.GzTags.CheckTagNameIsUnique(value),
        (response: { success: boolean }) => response.success,
        translateFn('Tag name already exists in the company.'),
        translateFn('A communication error has occurred. Please enter the tag name again.')
      )
    );
  }
}
